import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { Tag } from "antd";

import { GetEnumByValue } from "../../utils/enums";

const props = {
    className: PropTypes.string,
    value: PropTypes.any,
    enumObj: PropTypes.object.isRequired,
    colorObj: PropTypes.object,
    isColorEnum: PropTypes.bool,
};

const EnumTag = ({ className, value, enumObj, colorObj, isColorEnum }) => {
    const { t } = useTranslation();

    return (
        <Tag
            className={className ?? ""}
            color={isColorEnum ? GetEnumByValue(colorObj, value)?.color ?? "default" : colorObj?.[value]?.color ?? "default"}
        >
            {isColorEnum ? GetEnumByValue(enumObj, value)?.label : t(enumObj[value])}
        </Tag>
    );
};

EnumTag.propTypes = props;

export default EnumTag;
